import { FieldOptionBase } from 'module/api/field/types';
import { byLabel } from 'module/helpers/comparators/by-label';
import { optionsTransformer } from 'module/helpers/filter/option-transformer';
import { ClassNameOnlyProps } from 'module/types/common';
import { MultiSelectField } from 'module/types/filter-field/field/filterable-field';
import { Select } from '@rocketlane/ui';
import { FC, ReactNode, RefObject, useCallback } from 'react';
import styled from 'styled-components';
import { Popover } from '../components/components';
import type { SelectInstance } from 'react-select';

type Props = ClassNameOnlyProps & {
  field: MultiSelectField;
  title: ReactNode;
  onChange: (latest: number[]) => void;
  selectRef: RefObject<SelectInstance>;
};

const StyledPopover = styled(Popover)`
  height: 448px;
`;

export const ControlledMultiSelectFieldEditorPopover: FC<
  React.PropsWithChildren<Props>
> = ({ field, title, onChange, selectRef, className }) => {
  const {
    options: { activeOptions, allOptions },
  } = optionsTransformer(field);
  const onValueChange = useCallback(
    (latest: readonly FieldOptionBase[]) =>
      onChange?.([...latest].sort(byLabel).map((x) => x.value)),
    [onChange],
  );

  return (
    <StyledPopover className={className}>
      <Popover.Title>{title}</Popover.Title>
      <Select<FieldOptionBase, true>
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        isMulti
        menuFlush
        menuIsOpen
        menuPortalTarget={null}
        ref={selectRef}
        options={activeOptions}
        value={allOptions.filter((x) => (field.value ?? []).includes(x.value))}
        onChange={onValueChange}
        searchControl
        variant="basic"
        virtualized
      />
    </StyledPopover>
  );
};
